// extracted by mini-css-extract-plugin
export default {"base":"Password_base__IRFQk","root":"Password_root__D+Gsm","content":"Password_content__k8ZvQ","header":"Password_header__BX7bl","form":"Password_form__vvWSp"};